import apiClient from '@/api/client'

export interface TeacherUserResponse {
  id: string
  first_name?: string
  last_name?: string
  email: string
}

export interface CreateTeacherPayload {
  email: string
  first_name?: string
  last_name?: string
  password?: string // Optional - backend will generate if not provided
}

export const teachersApi = {
  async list(): Promise<TeacherUserResponse[]> {
    const { data } = await apiClient.get('/api/v1/users/teachers')
    return data
  },
  async create(payload: CreateTeacherPayload): Promise<TeacherUserResponse> {
    const { data } = await apiClient.post('/api/v1/users/teachers', payload)
    return data
  },
  async update(id: string, payload: Partial<TeacherUserResponse>): Promise<TeacherUserResponse> {
    const { data } = await apiClient.put(`/api/v1/users/${id}`, payload)
    return data
  },
  async remove(id: string): Promise<{ message: string }> {
    const { data } = await apiClient.delete(`/api/v1/users/${id}`)
    return data
  },
}



